<template>
  <div class="actions-menu">
    <h3 class="actions-menu__title">Действия по заявке</h3>

    <div class="actions-menu__btns">
      <router-link v-if="
      (status === 'Согласование' ||
      status === 'Не согласовано') &&
      permission.includes('bids.control')" :to="`/applications/${applicationsId}/edit`" class="actions-menu__btn">
        <Pencil class="color-primary" />
        <p class="actions-menu__btn-label">Редактировать</p>
      </router-link>
      <div  v-if="
                  status === 'Согласовано' &&
                  (role !== 'APPROVING_PERSON' || permission.includes('bids.approve'))
                  " class="actions-menu__btn" @click="takeWorkApp">
        <Pencil class="color-primary" />
        <p class="actions-menu__btn-label">Взять в работу</p>
      </div>

      <div  v-if="status === 'В работе' && createVacancy" class="actions-menu__btn" @click="takeWorkAppApply">
        <Check class="color-primary" />
        <p class="actions-menu__btn-label">Создать вакансию</p>
      </div>

      <div v-if="(
          status === 'Согласование' ||
          status === 'Не согласовано' ||
          status === 'Согласовано') &&
          permission.includes('bids.control')" @click="cancelApp" class="actions-menu__btn actions-menu__btn_red">
        <img src="@/assets/images/icons/close-red.svg" class="actions-menu__btn-icon" alt="pencil">
        <p class="actions-menu__btn-label">Отменить заявку</p>
      </div>

      <div v-if="status === 'В работе' && permission.includes('bids.take-to-work')" @click="closeApp" class="actions-menu__btn actions-menu__btn_red">
        <img src="@/assets/images/icons/close-red.svg" class="actions-menu__btn-icon" alt="pencil">
        <p class="actions-menu__btn-label">Закрыть заявку</p>
      </div>

      <VDivider v-if="status === 'Согласование'" style="margin-top: 12px; margin-bottom: 8px;" />

      <div  v-if="status === 'Согласование'" class="actions-menu__btn" @click="approveAppApply">
        <Check class="color-primary" />
        <p class="actions-menu__btn-label">Подтвердить заявку</p>
      </div>

      <div v-if="status === 'Согласование'"  @click="rejectApp" class="actions-menu__btn actions-menu__btn_red">
        <img src="@/assets/images/icons/close-red.svg" class="actions-menu__btn-icon" alt="pencil">
        <p class="actions-menu__btn-label">Отклонить заявку</p>
      </div>

      <ModalWindow v-if="modal" @close="cancel" class="actions-menu__modal-add-integration modal-app">
        <VModalWrapper class="wrapper-app" hidden-btn @close="cancel" :title="modalTitle">
          <div class="modal_desc">{{ modalDesc }}</div>
          <VCustomInput v-if="btnType === 'reject-app'" v-model="reject_reason" placeholder="Причина отклонения заявки*"/>
          <VButtonNew v-if="btnType === 'reject-app'" style-type="red" label="Отклонить заявку" @click="rejectAppApply" />

          <VButtonNew v-if="btnType === 'take-work-app'" label="Подтвердить и перейти" @click="takeWorkAppApply" />
          <VButtonNew v-if="btnType === 'close-app'" style-type="red" label="Закрыть заявку" @click="closeAppApply" />
          <VButtonNew v-if="btnType === 'cancel-app'" style-type="red" label="Отменить заявку" @click="cancelAppApply" />
          <VButtonNew @click="cancel" label="Отменить" style-type="grey"/>
        </VModalWrapper>
      </ModalWindow>

    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onActivated} from "vue";
import {useRouter, useRoute} from "vue-router";
import Pencil from "@/components/Icons/Pencil.vue";
import VDivider from "@/components/UI/VDivider/index.vue";
import ModalWindow from "@/components/ModalWindow/index.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import applications from "@/api/applications";
import VCustomInput from "@/components/UI/VCustomInput/index.vue";
import Check from "@/components/Icons/Check.vue";
import {useStore} from "vuex";
const router = useRouter()
const emit = defineEmits(["getData"]);
const route = useRoute();
const applicationsId = ref(route.params.id);
const permission = localStorage.getItem("profileInfo")
const store = useStore();
const role = store.getters["auth/role"];

const reject_reason = ref('')

defineProps({
  status: Boolean,
  createVacancy: Boolean,
})

const modal = ref(false);
const modalTitle = ref("");
const modalDesc = ref("");
const btnType = ref("");

const cancel = () => {
  modal.value = false;
}

const closeApp = () => {
  modal.value = true;
  modalDesc.value = "Вы действительно хотите закрыть заявку?";
  modalTitle.value = "Закрытие заявки";
  btnType.value = "close-app";
}

const cancelApp = () => {
  modal.value = true;
  modalDesc.value = "Вы уверены, что хотите отменить заявку?";
  modalTitle.value = "Отмена заявки";
  btnType.value = "cancel-app";
}

const rejectApp = () => {
  modal.value = true;
  modalDesc.value = "Укажите причину отклонения заявки";
  modalTitle.value = "Отклонение заявки";
  btnType.value = "reject-app";
}

const takeWorkApp = () => {
  modal.value = true;
  modalDesc.value = "Подтвердив, вы перейдете к созданию вакансии";
  modalTitle.value = "Взять в работу заявку?";
  btnType.value = "take-work-app";
}

const closeAppApply = async () => {
  await applications.closeApplications(applicationsId.value);
  modal.value = false;
  emit("getData");
}
const cancelAppApply = async () => {
  await applications.cancelApplications(applicationsId.value);
  modal.value = false;
  emit("getData");
}
const rejectAppApply = async () => {
  await applications.rejectApplications(applicationsId.value, {reject_reason: reject_reason.value});
  modal.value = false;
  emit("getData");
}

const approveAppApply = async () => {
  await applications.approveApplications(applicationsId.value);
  modal.value = false;
  emit("getData");
}

const takeWorkAppApply = async () => {
  const res = await applications.takeWorkApplications(applicationsId.value);
  await router.push("/vacancies/" + res?.data?.vacancy_id + "/edit");
}
</script>

<style scoped lang="scss">
.actions-menu {
  width: 249px;
  padding: 24px 16px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0 #0000000A;

  &__title {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.94px;
  }

  &__btns {
    margin-top: 16px;
  }

  &__btn {
    width: 100%;
    padding: 0 8px;
    height: 32px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    transition: .3s;
    cursor: pointer;
    text-decoration: none;
    user-select: none;

    &:not(:first-child) {
      margin-top: 8px;
    }

    &:hover {
      background-color: $light;
    }

    &:active {
      background-color: $light-gray-1;
    }
  }

  &__btn-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &__btn-label {
    margin-left: 8px;
    color: $blue;
    font-size: 14px;
    font-weight: 400;
  }

  &__btn_red &__btn-label {
    color: $red;
  }

  &__footer {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid $light-gray-1;
  }

  &__footer-close {
    margin-top: 16px;
  }

  &__modal-add-integration {
    &::v-deep(.modal__body) {
      width: 352px;
      height: auto;
      border-radius: 16px;
    }
  }
}
.color-primary {
  color: $primary-main;
}

.modal_desc {
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0;
  text-align: center;
  color: $dark;
  margin-bottom: 12px;
}

.wrapper-app {
  :deep(.modal-wrapper__title) {
    margin-right: 16px;
    margin-left: 16px;
  }
}
.modal-app {
  :deep(.modal-wrapper) {
    min-height: 240px;
  }
}
</style>
